import Cookies from 'js-cookie';
import Overlay from '../../../javascripts/utils/overlay';

class SocialEmbed {
  constructor($el) {
    this.$el = $el;
    this.type = $el.getAttribute('data-type');
    this.embedCode = $el.getAttribute('data-embedcode');
    this.consentCookieName = $el.getAttribute('data-cookie');
    this.$playButton = $el.querySelector('.social-embed__button');

    this.Overlay = new Overlay({
      onConsent: this.onConsent,
      onGlobalConsent: this.onGlobalConsent,
      consentCookieName: this.consentCookieName,
      $el: this.$el,
    });

    this.checkForCookie();
  }

  checkForCookie = () => {
    const neededCookie = Cookies.get(this.consentCookieName) || null;

    if (!neededCookie || neededCookie !== 'accept') {
      this.Overlay.init();
      // Init overlay only if not active yet
      if (!this.$el.classList.contains('social-embed__cookie-overlay-active')) {
        this.$el.classList.add('social-embed__cookie-overlay-active');
      }
    } else {
      this.Overlay.destroy();
      this.toggleEmbed();
    }
  }

  onConsent = () => {
    this.toggleEmbed();
  }

  onGlobalConsent = () => {
    // this.toggleEmbed();
    // eslint-disable-next-line
    initSocialEmbed();
  }

  toggleEmbed = () => {
    const $parent = this.$el;
    const regex = /<script.*?src="(.*?)"/;
    const isLoadedBefore = $parent.classList.contains('social-embed__cookie-consent');

    if (this.embedCode && !isLoadedBefore) {
      const embedHtml = decodeURIComponent(this.embedCode);

      $parent.insertAdjacentHTML('afterbegin', embedHtml);
      $parent.classList.remove('social-embed__cookie-overlay-active');
      $parent.classList.add('social-embed__cookie-consent');

      if (regex.exec(embedHtml) !== null) {
        const scriptSrc = regex.exec(embedHtml)[1];
        const newScript = document.createElement('script');
        newScript.setAttribute('async', true);
        newScript.src = scriptSrc;

        document.body.appendChild(newScript);
        $parent.querySelectorAll('script').forEach($el => $el.remove());
      }
    }

    if ($parent.querySelector('iframe')) {
      $parent.querySelector('iframe').contentWindow.focus();
    }
  }
}

export default function initSocialEmbed() {
  document.querySelectorAll('.js-social-embed').forEach($el => new SocialEmbed($el));
}

initSocialEmbed();
